// src/store/purchase-order-new/purchaseOrderReducer.js
import {
  CREATE_PURCHASE_ORDER_FAILURE,
  CREATE_PURCHASE_ORDER_REQUEST,
  CREATE_PURCHASE_ORDER_SUCCESS,
  DELETE_PURCHASE_ORDER_FAILURE,
  DELETE_PURCHASE_ORDER_REQUEST,
  DELETE_PURCHASE_ORDER_SUCCESS,
  EDIT_REQ_QTY_FAILURE,
  EDIT_REQ_QTY_REQUEST,
  EDIT_REQ_QTY_SUCCESS,
  GET_PURCHASE_ORDER_FAILURE,
  GET_PURCHASE_ORDER_REQUEST,
  GET_PURCHASE_ORDER_SUCCESS,
  PUBLISH_PURCHASE_ORDER_FAILURE,
  PUBLISH_PURCHASE_ORDER_REQUEST,
  PUBLISH_PURCHASE_ORDER_SUCCESS,
  GET_NOTACCEPTEDPURCHASEDORDERS_FAILURE,
  GET_NOTACCEPTEDPURCHASEDORDERS_REQUEST,
  GET_NOTACCEPTEDPURCHASEDORDERS_SUCCESS,
  GET_ACCEPTED_PURCHASE_ORDERS_REQUEST,
  GET_ACCEPTED_PURCHASE_ORDERS_SUCCESS,
  GET_ACCEPTED_PURCHASE_ORDERS_FAILURE,
  GET_LISTOFITEMS_REQUEST,
  GET_LISTOFITEMS_SUCCESS,
  GET_LISTOFITEMS_FAILURE,
  GET_VENDOR_CODE_REQUEST,
  GET_VENDOR_CODE_SUCCESS,
  GET_VENDOR_CODE_FAILURE,
  UPDATE_ACCEPTPO_REQUEST,
  UPDATE_ACCEPTPO_SUCCESS,
  UPDATE_ACCEPTPO_FAILURE,
  UPDATE_REJECTPO_REQUEST,
  UPDATE_REJECTPO_SUCCESS,
  UPDATE_REJECTPO_FAILURE,
  UPDATE_ACCEPTPO_BULK_REQUEST,
  UPDATE_ACCEPTPO_BULK_SUCCESS,
  UPDATE_ACCEPTPO_BULK_FAILURE,
  UPDATE_REJECTPO_BULK_REQUEST,
  UPDATE_REJECTPO_BULK_SUCCESS,
  UPDATE_REJECTPO_BULK_FAILURE,
  GET_RELEASED_PURCHASE_ORDERS_REQUEST,
  GET_RELEASED_PURCHASE_ORDERS_SUCCESS,
  GET_RELEASED_PURCHASE_ORDERS_FAILURE,
  GET_DELIVERY_PLANT_FOR_PO_REQUEST,
  GET_DELIVERY_PLANT_FOR_PO_SUCCESS,
  GET_DELIVERY_PLANT_FOR_PO_FAILURE,
  GET_UNLOADING_POINT_FOR_PO_REQUEST,
  GET_UNLOADING_POINT_FOR_PO_SUCCESS,
  GET_UNLOADING_POINT_FOR_PO_FAILURE,
  UPLOAD_EXCEL_FOR_PURCHASE_ORDER_REQUEST,
  UPLOAD_EXCEL_FOR_PURCHASE_ORDER_SUCCESS,
  UPLOAD_EXCEL_FOR_PURCHASE_ORDER_FAILURE,
  GET_VENDOR_PURCHASE_ORDER_REQUEST,
  GET_VENDOR_PURCHASE_ORDER_SUCCESS,
  GET_VENDOR_PURCHASE_ORDER_FAILURE,
  GET_CLIENT_REJECTED_POS_REQUEST,
  GET_CLIENT_REJECTED_POS_SUCCESS,
  GET_CLIENT_REJECTED_POS_FAILURE,
  GET_VENDOR_REJECTED_POS_REQUEST,
  GET_VENDOR_REJECTED_POS_SUCCESS,
  GET_VENDOR_REJECTED_POS_FAILURE,
  GET_ACCEPTED_PO_CLIENT_REQUEST,
  GET_ACCEPTED_PO_CLIENT_SUCCESS,
  GET_ACCEPTED_PO_CLIENT_FAILURE,
  GET_ACCEPTED_PO_VENDOR_REQUEST,
  GET_ACCEPTED_PO_VENDOR_SUCCESS,
  GET_ACCEPTED_PO_VENDOR_FAILURE,
  GET_ATTACHMENT_CLIENT_REQUEST,
  GET_ATTACHMENT_CLIENT_SUCCESS,
  GET_ATTACHMENT_CLIENT_FAILURE,
  GET_VENDOR_INVOICE_REQUEST,
  GET_VENDOR_INVOICE_SUCCESS,
  GET_VENDOR_INVOICE_FAILURE
} from "./purchaseOrderNewTypes";

// PO list
const initialStateForGetPurchaseOrder = {
  loading: false,
  purchaseOrders: [],
  error: "",
};
const getPurchaseOrderReducer = (
  state = initialStateForGetPurchaseOrder,
  action
) => {
  switch (action.type) {
    case GET_PURCHASE_ORDER_REQUEST:
      return { ...state, loading: true };
    case GET_PURCHASE_ORDER_SUCCESS:
      return { loading: false, purchaseOrders: action.payload, error: "" };
    case GET_PURCHASE_ORDER_FAILURE:
      return { loading: false, purchaseOrders: [], error: action.payload };
    default:
      return state;
  }
};

// Released list
const initialStateForAcceptedGetPurchaseOrder = {
  loading: false,
  acceptedOrders: [],
  error: "",
};
const getReleasedPurchaseOrderReducer = (
  state = initialStateForAcceptedGetPurchaseOrder,
  action
) => {
  switch (action.type) {
    case GET_RELEASED_PURCHASE_ORDERS_REQUEST:
      return { ...state, loading: true };
    case GET_RELEASED_PURCHASE_ORDERS_SUCCESS:
      return { loading: false, acceptedOrders: action.payload, error: "" };
    case GET_RELEASED_PURCHASE_ORDERS_FAILURE:
      return { loading: false, acceptedOrders: [], error: action.payload };
    default:
      return state;
  }
};

// Create
const initialStateForCreate = { loading: false, purchase: {}, error: "" };
const createPurchaseOrderReducer = (state = initialStateForCreate, action) => {
  switch (action.type) {
    case CREATE_PURCHASE_ORDER_REQUEST:
      return { ...state, loading: true };
    case CREATE_PURCHASE_ORDER_SUCCESS:
      return { loading: false, purchase: action.payload, error: "" };
    case CREATE_PURCHASE_ORDER_FAILURE:
      return { loading: false, purchase: {}, error: action.payload };
    default:
      return state;
  }
};

// Edit
const initialStateForEdit = { loading: false, purchaseEdit: {}, error: "" };
const editPurchaseOrderReducer = (state = initialStateForEdit, action) => {
  switch (action.type) {
    case EDIT_REQ_QTY_REQUEST:
      return { ...state, loading: true };
    case EDIT_REQ_QTY_SUCCESS:
      return { loading: true, purchaseEdit: action.payload, error: "" };
    case EDIT_REQ_QTY_FAILURE:
      return { loading: false, purchaseEdit: {}, error: action.payload };
    default:
      return state;
  }
};

// Delete
const initialStateForDelete = { loading: false, deleteOrder: {}, error: "" };
const deletePurchaseOrderReducer = (state = initialStateForDelete, action) => {
  switch (action.type) {
    case DELETE_PURCHASE_ORDER_REQUEST:
      return { ...state, loading: true };
    case DELETE_PURCHASE_ORDER_SUCCESS:
      return { loading: false, deleteOrder: action.payload, error: "" };
    case DELETE_PURCHASE_ORDER_FAILURE:
      return { loading: false, deleteOrder: {}, error: action.payload };
    default:
      return state;
  }
};

// Publish (release)
const initialStateForPublish = { loading: false, publish: {}, error: "" };
const publishPurchaseOrderReducer = (
  state = initialStateForPublish,
  action
) => {
  switch (action.type) {
    case PUBLISH_PURCHASE_ORDER_REQUEST:
      return { ...state, loading: true };
    case PUBLISH_PURCHASE_ORDER_SUCCESS:
      return { loading: false, publish: action.payload, error: "" };
    case PUBLISH_PURCHASE_ORDER_FAILURE:
      return { loading: false, publish: {}, error: action.payload };
    default:
      return state;
  }
};

// listOfItems (kept as reference; optional)
const initialStateForListOfItems = {
  loading: false,
  listOfItems: {},
  error: "",
};
const listOfItemsReducer = (state = initialStateForListOfItems, action) => {
  switch (action.type) {
    case GET_LISTOFITEMS_REQUEST:
      return { ...state, loading: true };
    case GET_LISTOFITEMS_SUCCESS:
      return { loading: false, listOfItems: action.payload, error: "" };
    case GET_LISTOFITEMS_FAILURE:
      return { loading: false, listOfItems: {}, error: action.payload };
    default:
      return state;
  }
};

// Not accepted list
const initialStateForNotAccepted = {
  loading: false,
  notAcceptedpurchasedOrders: {},
  error: "",
};
const notAcceptedPurchasedOrdersReducer = (
  state = initialStateForNotAccepted,
  action
) => {
  switch (action.type) {
    case GET_NOTACCEPTEDPURCHASEDORDERS_REQUEST:
      return { ...state, loading: true };
    case GET_NOTACCEPTEDPURCHASEDORDERS_SUCCESS:
      return {
        loading: false,
        notAcceptedpurchasedOrders: action.payload,
        error: "",
      };
    case GET_NOTACCEPTEDPURCHASEDORDERS_FAILURE:
      return {
        loading: false,
        notAcceptedpurchasedOrders: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

// Vendors list
const initialStateForVendorCode = { loading: false, vendors: [], error: "" };
const getVendorCodeReducer = (state = initialStateForVendorCode, action) => {
  switch (action.type) {
    case GET_VENDOR_CODE_REQUEST:
      return { ...state, loading: true };
    case GET_VENDOR_CODE_SUCCESS:
      return { loading: false, vendors: action.payload, error: "" };
    case GET_VENDOR_CODE_FAILURE:
      return { loading: false, vendors: [], error: action.payload };
    default:
      return state;
  }
};

// Vendor ACCEPT (single)
const initialStateForAccept = { loading: false, accept: {}, error: "" };
const acceptPoReducer = (state = initialStateForAccept, action) => {
  switch (action.type) {
    case UPDATE_ACCEPTPO_REQUEST:
      return { ...state, loading: true };
    case UPDATE_ACCEPTPO_SUCCESS:
      return { loading: true, accept: action.payload, error: "" };
    case UPDATE_ACCEPTPO_FAILURE:
      return { loading: false, accept: {}, error: action.payload };
    default:
      return state;
  }
};

// Vendor REJECT (single)
const initialStateForReject = { loading: false, reject: {}, error: "" };
const rejectPoReducer = (state = initialStateForReject, action) => {
  switch (action.type) {
    case UPDATE_REJECTPO_REQUEST:
      return { ...state, loading: true };
    case UPDATE_REJECTPO_SUCCESS:
      return { loading: false, reject: action.payload, error: "" };
    case UPDATE_REJECTPO_FAILURE:
      return { loading: false, reject: {}, error: action.payload };
    default:
      return state;
  }
};

// Vendor ACCEPT (bulk) optional
const initialStateForAcceptBulk = { loading: false, acceptBulk: {}, error: "" };
const acceptPoBulkReducer = (state = initialStateForAcceptBulk, action) => {
  switch (action.type) {
    case UPDATE_ACCEPTPO_BULK_REQUEST:
      return { ...state, loading: true };
    case UPDATE_ACCEPTPO_BULK_SUCCESS:
      return { loading: false, acceptBulk: action.payload, error: "" };
    case UPDATE_ACCEPTPO_BULK_FAILURE:
      return { loading: false, acceptBulk: {}, error: action.payload };
    default:
      return state;
  }
};

// Vendor REJECT (bulk) optional
const initialStateForRejectBulk = { loading: false, rejectBulk: {}, error: "" };
const rejectPoBulkReducer = (state = initialStateForRejectBulk, action) => {
  switch (action.type) {
    case UPDATE_REJECTPO_BULK_REQUEST:
      return { ...state, loading: true };
    case UPDATE_REJECTPO_BULK_SUCCESS:
      return { loading: false, rejectBulk: action.payload, error: "" };
    case UPDATE_REJECTPO_BULK_FAILURE:
      return { loading: false, rejectBulk: {}, error: action.payload };
    default:
      return state;
  }
};

// Accepted POs list
const initialStateForAccepted = { loading: false, accepted: {}, error: "" };
const acceptedPoReducer = (state = initialStateForAccepted, action) => {
  switch (action.type) {
    case GET_ACCEPTED_PURCHASE_ORDERS_REQUEST:
      return { ...state, loading: true };
    case GET_ACCEPTED_PURCHASE_ORDERS_SUCCESS:
      return { loading: false, accepted: action.payload, error: "" };
    case GET_ACCEPTED_PURCHASE_ORDERS_FAILURE:
      return { loading: false, accepted: {}, error: action.payload };
    default:
      return state;
  }
};

// Unloading point
const initialStateForUnloadingPoint = {
  loading: false,
  unloadingPointData: {},
  error: "",
};
const unloadingPointForPOReducer = (
  state = initialStateForUnloadingPoint,
  action
) => {
  switch (action.type) {
    case GET_UNLOADING_POINT_FOR_PO_REQUEST:
      return { ...state, loading: true };
    case GET_UNLOADING_POINT_FOR_PO_SUCCESS:
      return { loading: false, unloadingPointData: action.payload, error: "" };
    case GET_UNLOADING_POINT_FOR_PO_FAILURE:
      return { loading: false, unloadingPointData: {}, error: action.payload };
    default:
      return state;
  }
};

// Delivery plant
const initialStateForDeliveryPlant = {
  loading: false,
  deliveryPlantData: {},
  error: "",
};
const deliveryPlantForPOReducer = (
  state = initialStateForDeliveryPlant,
  action
) => {
  switch (action.type) {
    case GET_DELIVERY_PLANT_FOR_PO_REQUEST:
      return { ...state, loading: true };
    case GET_DELIVERY_PLANT_FOR_PO_SUCCESS:
      return { loading: false, deliveryPlantData: action.payload, error: "" };
    case GET_DELIVERY_PLANT_FOR_PO_FAILURE:
      return { loading: false, deliveryPlantData: {}, error: action.payload };
    default:
      return state;
  }
};

const initialStateForGetVendorPurchaseOrder = {
  loading: false,
  purchaseOrders: [],
  error: "",
};
const getVendorPurchaseOrderReducer = (
  state = initialStateForGetVendorPurchaseOrder,
  action
) => {
  switch (action.type) {
    case GET_VENDOR_PURCHASE_ORDER_REQUEST:
      return { ...state, loading: true };
    case GET_VENDOR_PURCHASE_ORDER_SUCCESS:
      return { loading: false, purchaseOrders: action.payload, error: "" };
    case GET_VENDOR_PURCHASE_ORDER_FAILURE:
      return { loading: false, purchaseOrders: [], error: action.payload };
    default:
      return state;
  }
};

// Client rejected list
const initialStateForClientRejected = {
  loading: false,
  purchaseOrders: [],
  error: "",
};
const getClientRejectedPurchaseOrdersReducer = (
  state = initialStateForClientRejected,
  action
) => {
  switch (action.type) {
    case GET_CLIENT_REJECTED_POS_REQUEST:
      return { ...state, loading: true };
    case GET_CLIENT_REJECTED_POS_SUCCESS:
      return { loading: false, purchaseOrders: action.payload, error: "" };
    case GET_CLIENT_REJECTED_POS_FAILURE:
      return { loading: false, purchaseOrders: [], error: action.payload };
    default:
      return state;
  }
};

// Vendor rejected list
const initialStateForVendorRejected = {
  loading: false,
  purchaseOrders: [],
  error: "",
};
const getVendorRejectedPurchaseOrdersReducer = (
  state = initialStateForVendorRejected,
  action
) => {
  switch (action.type) {
    case GET_VENDOR_REJECTED_POS_REQUEST:
      return { ...state, loading: true };
    case GET_VENDOR_REJECTED_POS_SUCCESS:
      return { loading: false, purchaseOrders: action.payload, error: "" };
    case GET_VENDOR_REJECTED_POS_FAILURE:
      return { loading: false, purchaseOrders: [], error: action.payload };
    default:
      return state;
  }
};

const initialStateForAcceptedPoClient = {
  loading: false,
  acceptedPoClient: [],
  error: "",
};

const acceptedPoClientReducer = (
  state = initialStateForAcceptedPoClient,
  action
) => {
  switch (action.type) {
    case GET_ACCEPTED_PO_CLIENT_REQUEST:
      return { ...state, loading: true };
    case GET_ACCEPTED_PO_CLIENT_SUCCESS:
      return { loading: false, acceptedPoClient: action.payload, error: "" };
    case GET_ACCEPTED_PO_CLIENT_FAILURE:
      return { loading: false, acceptedPoClient: [], error: action.payload };
    default:
      return state;
  }
};

const initialStateForAcceptedPoVendor = {
  loading: false,
  acceptedPoVendor: [],
  error: "",
};

const acceptedPoVendorReducer = (
  state = initialStateForAcceptedPoVendor,
  action
) => {
  switch (action.type) {
    case GET_ACCEPTED_PO_VENDOR_REQUEST:
      return { ...state, loading: true };
    case GET_ACCEPTED_PO_VENDOR_SUCCESS:
      return { loading: false, acceptedPoVendor: action.payload, error: "" };
    case GET_ACCEPTED_PO_VENDOR_FAILURE:
      return { loading: false, acceptedPoVendor: [], error: action.payload };
    default:
      return state;
  }
};

const initialState = {
  loading: false,
  url: null,
  error: null,
};

const getAttechmentClientReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ATTACHMENT_CLIENT_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_ATTACHMENT_CLIENT_SUCCESS:
      return { ...state, loading: false, url: action.payload, error: null };
    case GET_ATTACHMENT_CLIENT_FAILURE:
      return { ...state, loading: false, url: null, error: action.payload };
    default:
      return state;
  }
};



const initialStateForGetVendorInvoice = {
  loading: false,
  invoices: [],
  error: "",
};

 const getVendorInvoiceReducer = (
  state = initialStateForGetVendorInvoice,
  action
) => {
  switch (action.type) {
    case GET_VENDOR_INVOICE_REQUEST:
      return {
        ...state,
        loading: true,
        // optionally clear previous error on new request
        error: "",
      };
    case GET_VENDOR_INVOICE_SUCCESS:
      return {
        loading: false,
        invoices: action.payload,
        error: "",
      };
    case GET_VENDOR_INVOICE_FAILURE:
      return {
        loading: false,
        invoices: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export {
  getPurchaseOrderReducer,
  createPurchaseOrderReducer,
  editPurchaseOrderReducer,
  deletePurchaseOrderReducer,
  publishPurchaseOrderReducer,
  listOfItemsReducer,
  notAcceptedPurchasedOrdersReducer,
  getVendorCodeReducer,
  acceptPoReducer,
  rejectPoReducer,
  acceptPoBulkReducer,
  rejectPoBulkReducer,
  getReleasedPurchaseOrderReducer,
  acceptedPoReducer,
  unloadingPointForPOReducer,
  deliveryPlantForPOReducer,
  getVendorPurchaseOrderReducer,
  getClientRejectedPurchaseOrdersReducer,
  getVendorRejectedPurchaseOrdersReducer,
  acceptedPoClientReducer,
  acceptedPoVendorReducer,
  getAttechmentClientReducer,
  getVendorInvoiceReducer,
};
